// extracted by mini-css-extract-plugin
export var aiStarSpin = "_nd-1";
export var spinner = "_nd-0";